import SankeyChart from "./SankeyChart/SankeyChart";
import StackedBarChart from "./StackedBarChart/StackedBarChart";
import MyComposedChart from "./ComposedChart/ComposedChart";
import StockChart from "./StockChart/StockChart";

const Charts = {
  Composed: MyComposedChart,
  Sankey: SankeyChart,
  StackedBar: StackedBarChart,
  Stock: StockChart,
};

export default Charts;
